import Api from '@/api/index';

const BankAccount = {
  namespaced: true,
  state: { 
    errorMessage: null,
    errorActive: null,
  },
  mutations: {// altera os dados do state
    setErrorMessage(state, {message, status}){
      state.errorMessage = message;
      state.errorActive = status;
      setTimeout(() => {
        state.errorMessage = null
        state.errorActive = null
      }, 500 );
    }
  },
  actions: { //chamar o método dentro dos componentes
    delete(context, id){
      Api.BankAccount.delete(id)
        .then(response => response.data)
        .then(banks =>{
          context.commit('setErrorMessage', {message: '', status: false})
        }).catch(function(error) {
          console.log(error);
          context.commit('setErrorMessage', {message: error, status: true})
        });
    },
  }
};

export default BankAccount;